import { gql } from "apollo-angular";
import { ADDRESS_FIELDS_FOR_DROPDOWN_FRAGMENT } from "./address-dropdown-fragment.definition";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { POSTALADDRESS_FRAGMENT } from "./postal-address-definition";

export const ADDRESS_POSTAL_LINK_LIGHT_FRAGMENT = gql`
fragment AddressPostalLinkLight on AddressPostalLink {
    ...IBaseModel
    postalAddressId
    postalAddress {
        ...PostalAddress
    }
    addressId
    address {
        ...AddressFieldsForDropdown
    }
    isDefault
    notes
    version
}
${BASEMODEL_FRAGMENT}
${POSTALADDRESS_FRAGMENT}
${ADDRESS_FIELDS_FOR_DROPDOWN_FRAGMENT}
`;

export const GET_ADDRESS_POSTAL_LINKS_DROP_DOWN_LIGHT = gql`
query GetAddressPostalLinksDropDownList($input: AddressPostalLinkSearchInput) {
        getAddressPostalLinks(input: $input) {
            totalItems
            items {
                ... AddressPostalLinkLight
            }
        }
    }
${ADDRESS_POSTAL_LINK_LIGHT_FRAGMENT}
`;